// Scanner Feeds list — Session C migration to the FwTable pattern.
// Same request shape as the AgTable page it replaces; columns from
// agModule.json; permission gates unchanged.
import ModuleListPage from "elements/Table/ModuleListPage";

export default function List() {
  return (
    <ModuleListPage
      module="feed"
      title="Scanner Feeds"
      api="admin/feed"
      url="feed"
      columnsKey="feed"
      quickKey="name"
      quickPlaceholder="Filter by name…"
      localityFilter
      perms={["sfr", "sfc", "sfu", "sfd"]}
    />
  );
}
